module.exports = __webpack_public_path__ + "static/img/env07.81833bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env07.png
// module id = 587
// module chunks = 4